/**
 * Download a file from a URL. Uses the File System Access API (showSaveFilePicker)
 * when available (Chrome/Edge), which opens a native OS Save dialog that works
 * even inside iframes. Falls back to blob+link for other browsers.
 */
export async function downloadFile(url, filename) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Download failed: ${response.status}`);
  const blob = await response.blob();

  // Method 1: File System Access API — native OS Save dialog, works inside iframes
  if (window.showSaveFilePicker) {
    try {
      const ext = filename.split('.').pop();
      const types = ext === 'pdf'
        ? [{ description: 'PDF', accept: { 'application/pdf': ['.pdf'] } }]
        : [{ description: 'CSV', accept: { 'text/csv': ['.csv'] } }];

      const handle = await window.showSaveFilePicker({ suggestedName: filename, types });
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return true;
    } catch (err) {
      if (err.name === 'AbortError') return false;
      // showSaveFilePicker blocked — fall through to blob method
    }
  }

  // Method 2: Blob + link.click — scheduled after a small delay to avoid dialog overlay interception
  return new Promise((resolve) => {
    setTimeout(() => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 200);
      resolve(true);
    }, 300);
  });
}
